<template>
    <div>
        {{row.type}} - {{$trans(row.name)}}
    </div>
</template>


<script>

    export default {

        props: {
            row: {
                type: Object,
                default: () => {}
            }
        }

    }
</script>